import { faqItemLocaleVisibilityFilter } from '@pkg/sanity-utils/faqItemLocaleVisibilityFilter';
import { translatedFieldQuery } from '@pkg/sanity-utils/translatedFieldQuery';
import groq from 'groq';
import { portableEditorFields } from '@pkg/portable-text-editor/web/portableEditor/groq';
import { maxPathDepth } from '@pkg/config/misc/supportPaths';
import { formWithReferences } from '@pkg/sanity-utils/formWithReferences'
import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';

/**
 * When loading this Block in a modular content block, the following fields will be loaded.
 * Ensure all fields used in your block are loaded below.
 * _type and _key will always be included, and do not need to be specified below.
 *
 * The fields are loaded with the "..." selector, to get all fields for the block.
 * However, if you need to follow references, rename fields, or do anything else other than
 * get fields, then add these extra bits to the groq export below.
 *
 * If you use inner blocks, these must be in a `content` field.
 *
 * It will then be included like so:
 *   ...,
 *   _type == "YOUR_BLOCK" => {
 *     YOUR_FIELDS,
 *   }
 */
export const blockSupportSectionFields = groq`
  supportPath->{
    ...,
    ${choicesGroq(1)},
  }
`;

function choicesGroq(depth = 1): string {
  if (depth > maxPathDepth) return '';

  return groq`
    itemChoices[] {
      ...,
      faqsToDisplay[]->{
        items[${faqItemLocaleVisibilityFilter}] {
          _key,
          analyticsProperty,
          ${translatedFieldQuery('question')},
          ${translatedFieldQuery('answer')}[] {
            ${portableEditorFields},
            ${portableTextWithReferences}
          }
        }
      },
      formToDisplay->{
        ${formWithReferences}
      },
      ${choicesGroq(depth + 1)}
    }
  `;
}
